var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{attrs:{"cols":"3"}},_vm._l((_vm.files),function(file){return _c('b-row',{key:file._id,staticClass:"p-2 border-top"},[_c('b-col',[_vm._v(_vm._s(file.deviceId))]),_c('b-col',[_vm._v(_vm._s(file.fileName))]),_c('b-col',[_vm._v(_vm._s(file.assignedToName))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }